import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseFunctionalitiesPresetId = (store: StoreSchema) =>
	store.license.licenseEditable.functionalitiesPresetId